import { createSlice } from "@reduxjs/toolkit";
import { DataConversionAudioActuacionService, DataLiberacionAudioActuacionService } from "interfaces/audioActuacion/audioActuacionInterfaces";

interface ReducerAudioActuacionConversion {
  dataConversionActuacion: DataConversionAudioActuacionService | null;
  dataLiberaActuacion: DataLiberacionAudioActuacionService | null;
  labelButtonConvertir: string;
}
export const audioActuacionSlice = createSlice({
  name: "audioActuacionConversion",
  initialState: {
    dataConversionActuacion: null,
    dataLiberaActuacion: null,
    labelButtonConvertir: 'Generar Audio',
  } as ReducerAudioActuacionConversion,
  reducers: {
    onLoadLiberacionActuacion: (state, { payload }) => {
        state.dataLiberaActuacion = payload;
    },
    onLoadConversionActuacion: (state, { payload }) => {
        state.dataConversionActuacion = payload;
    },
    onChangeLabelButtonConvertir: (state, { payload }) => {
        state.labelButtonConvertir = payload;
    }
  },
});

//actions creators are generated for each case reducer function
export const { onLoadLiberacionActuacion, onLoadConversionActuacion, onChangeLabelButtonConvertir } =
audioActuacionSlice.actions;
